/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomerGatewayBalances} from '../api'

 export const useQueryGetCustomerGatewayBalances = createReactQueryHook('getCustomerGatewayBalances', getCustomerGatewayBalances)
